import React from 'react';
import { Link } from 'react-router-dom';

const AboutHero: React.FC = () => {
    return (
        <section id="about-section" className="bg-white px-2 flex flex-col items-center min-h-[80vh] mt-16 relative overflow-hidden">
            <div className="pt-[30vh] pb-[30vh] w-full flex flex-col items-center">
                <h1 className="text-5xl md:text-6xl font-extrabold text-center mb-3 pb-4 text-[#4169e1] drop-shadow-sm z-10 leading-tight tracking-tight">
                    Pioneering Water Solutions Since 2008
                </h1>
                <p className="text-2xl md:text-3xl text-[#4169e1] text-center mb-8 pb-4 font-light font-medium z-10 max-w-2xl">
                    Empowering Zimbabwe with reliable, clean, and sustainable water resources since 2008.
                </p>
            </div>
            <div className="flex flex-col md:flex-row items-center justify-center gap-10 w-full max-w-6xl z-10">
                {/* Image with border and shadow */}
                <div className="flex-1 flex justify-center items-center relative">
                    <div className="relative w-full max-w-md">
                        <img
                            src="/images/pics/abouthero.webp"
                            alt="Springwaters team at work"
                            loading="lazy"
                            className="w-full h-auto rounded-3xl shadow-2xl border-8 border-white object-cover relative z-10"
                        />
                    </div>
                </div>
                {/* Company Story */}
                <div className="flex-1 text-center md:text-left space-y-6">
                    <p className="text-base md:text-lg text-[#0a2259] font-medium leading-relaxed">
                        <span className="font-bold text-[#4169e1]">Springdrill (Private) Limited</span>, trading as Springwaters, was officially incorporated on 8th April 2008 in Harare, Zimbabwe.<br /><br />
                        Our vision: to empower Zimbabwean communities, industries, and farms with reliable, clean, and sustainable water resources.<br /><br />
                        As a wholly Zimbabwean-owned company, we take immense pride in contributing directly to the nation's development and well-being. Our deep understanding of local hydrology, environmental conditions, and community needs sets us apart.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutHero; 